import { getModeOfNotification } from '../HelperFunctions';
import AddButton from '../authorised/impressionFinding/exam/findingActions/AddButton';

export default function Input(props) {
  const { input, disabled, placeholder, autoComplete, wrapperClasses, label, isModeOfNotificationDefaultVal, readOnly, meta: { touched, error, warning }, findingAutoComplete, handleOnAddFindings, FindingAutoCompleteComp, findingDropdownProps, findingWrapperClasses } = props

  return (
    <div className={`${disabled && 'disabled'} ${wrapperClasses}`}>
      {label !== undefined && <label>{props.label}</label>}
      <div className={`${findingAutoComplete && 'd-flex'}`}>
        <input
          {...input}
          value={isModeOfNotificationDefaultVal ? getModeOfNotification(input.value) : input.value}
          autoComplete={autoComplete}
          placeholder={placeholder}
          type={props.type}
          readOnly={readOnly}
          disabled={props.disabled || false}
          className={`${props.className} ${touched && error && 'is-invalid'}`}
        />
        {findingAutoComplete && <AddButton name={input.name} value={input.value} handleOnAddFindings={handleOnAddFindings} />}
      </div>
      {FindingAutoCompleteComp && <div className={`${findingWrapperClasses}`}>
        <FindingAutoCompleteComp {...findingDropdownProps} />
      </div>}
      {touched &&
        ((error && <span className="invalid-feedback text-danger d-inline la-sm">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  )
}
